<template>
	<div class="row contentblock">
		<div class="column6 col-image">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="column6 col-content">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	padding: 0;
	margin: 0 auto 80px;
	position: relative;

	&:nth-child(odd) {
		flex-direction: row-reverse;

		.col-image {
			left: 70px;
			right: auto;
		}
	}

	.columns:first-child {
		padding: 0;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.col-content {
		padding: 50px 0;
		position: relative;
		z-index: 2;
	}

	.col-image {
		position: absolute;
		top: 0;
		right: 70px;
		bottom: 0;
		width: 54%;
	}

	.contentblock-content {
		padding: 75px;
		margin: 0 70px;
		background: #fff;
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.col-image {
			width: 90%;
			position: relative;
			left: unset !important;
		}

		.col-content {
			padding: 0;
			width: 92%;
			margin: -50px auto 0;
		}

		.contentblock-content {
			padding: 50px;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		display: flex;
		position: relative;
		margin: 0;

		.contentblock-content {
			padding: 35px;
			margin: -20px 20px 0;

			:deep(h3) {
				font-size: 30px;
			}

			:deep(p) {
				font-size: 16px;
			}

			:deep(.button) {
				width: 100%;
				text-align: center;
			}
		}

		.col-image {
			all: unset;
			position: relative;
			margin: 20px;
			aspect-ratio: 1;
		}

		&:nth-child(odd) {
			.col-image {
				all: unset;
				left: unset !important;
				position: relative;
				margin: 20px;
				aspect-ratio: 1;
			}
		}
	}
}
</style>
